import React, { Component } from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import LoaderButton from "../LoaderButton"; // adjust as needed
import {
  updateUserProfileByEmail,
  getUserProfileByEmail,
} from "../../libs/API"; // adjust as neededimport Popup from "reactjs-popup";
import Popup from "reactjs-popup";

class UserProfilePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      department: "",
      division: "",
      title: "",
      isAttributesLoading: false,
      attributesErrorMessage: "",
      attributesSuccessMessage: "",
    };
  }

  componentDidMount() {
    this.loadUserAttributes();
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  closePopup = () => {
    this.setState({
      isAttributesLoading: false,
      attributesErrorMessage: "",
      attributesSuccessMessage: "",
    });
    this.props.onHide();
  };

  loadUserAttributes = async () => {
    try {
      const userEmail = this.props.clickedUserEmail;
      if (userEmail === undefined || userEmail === null || userEmail === "") {
        return;
      }
      await getUserProfileByEmail(userEmail)
        .then((response) => {
          console.log("User profile retrieved:", response.data);
          this.setState((prevState) => ({
            firstName:
              response.data.name !== null
                ? response.data.name
                : prevState.firstName,
            lastName:
              response.data.familyname !== null
                ? response.data.familyname
                : prevState.lastName,
            department:
              response.data.departmentName !== null
                ? response.data.departmentName
                : prevState.department,
            division:
              response.data.division !== null
                ? response.data.division
                : prevState.division,
            title:
              response.data.title !== null
                ? response.data.title
                : prevState.title,
          }));
        })
        .catch((err) => {
          console.error("Error retrieving profile:", err);
        });
    } catch (err) {
      console.error("Error loading user attributes:", err);
    }
  };

  handleAttributesSubmit = async (e) => {
    e.preventDefault();
    // Clear previous messages and set loading state
    this.setState({
      isAttributesLoading: true,
      attributesErrorMessage: "",
      attributesSuccessMessage: "",
    });
    try {
      const userDetails = {
        UserEmail: this.props.clickedUserEmail,
        Name: this.state.firstName,
        Familyname: this.state.lastName,
        Title: this.state.title,
        DepartmentName: this.state.department,
        Division: this.state.division,
      };

      await updateUserProfileByEmail(userDetails)
        .then((response) => {
          console.log("Profile updated successfully:", response.data);
          this.setState({
            attributesSuccessMessage: "User Profile saved successfully",
            isAttributesLoading: false,
          });
        })
        .catch((err) => {
          console.error("Error updating profile:", err);
          this.setState({
            attributesErrorMessage: err.message,
            isAttributesLoading: false,
          });
        });
    } catch (err) {
      this.setState({
        attributesErrorMessage: err.message,
        isAttributesLoading: false,
      });
    }
  };

  render() {
    return (
      <Popup
        open={this.props.show}
        modal
        closeOnDocumentClick={false}
        onClose={this.closePopup}
        contentStyle={{
          width: "80%", // Make popup wider
          maxWidth: "900px", // Limit maximum width
          borderRadius: "10px",
          padding: "20px",
          background: "#fff", // White background
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div>
          {/* eslint-disable-next-line */}
          <a
            className="close"
            onClick={this.closePopup}
            style={{ color: "#999" }}
          >
            &times;
          </a>
          <form autoComplete="off" onSubmit={this.handleAttributesSubmit}>
            <fieldset className="my-fieldset">
              <legend className="login-legend">User Profile</legend>
              <FormGroup controlId="firstName">
                <ControlLabel>First Name:</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.firstName}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="lastName">
                <ControlLabel>Family Name:</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.lastName}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="department">
                <ControlLabel>Department:</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.department}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="division">
                <ControlLabel>Division:</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.division}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="title">
                <ControlLabel>Title:</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.title}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup>
                <LoaderButton
                  block
                  bsClass="btn btn-outline-secondary"
                  type="submit"
                  isLoading={this.state.isAttributesLoading}
                  text="Save User Details"
                  loadingText="Saving Details…"
                />
              </FormGroup>
              <span className="errorMessage">
                {this.state.attributesErrorMessage}
              </span>
              <span className="successMessage">
                {this.state.attributesSuccessMessage}
              </span>
            </fieldset>
          </form>
        </div>
      </Popup>
    );
  }
}

export default UserProfilePopup;
